module.exports = __webpack_public_path__ + "img/hero_portrait_lg-min.8c575744.png";